import { InvoiceDisplayStatusV2, PaymentDetailType } from 'anchor-scout-common/types';
import { Intent } from '~/infra/access-control';
import { invoiceModel, invoiceSummaryModel, timeModel } from '~/models';
export const invoiceLogicTextsPath = 'invoiceLogic';
function isPaymentDetailWithDate(detail) {
    return 'date' in detail;
}
export function getStatusLabel(displayedStatus, texts) {
    return texts[displayedStatus]();
}
const PAYMENT_DETAIL_TOOLTIP_TEXT_KEY = {
    [PaymentDetailType.PaymentAwaitingInitiation]: 'paymentAwaitingInitiation',
    [PaymentDetailType.PaymentInitiated]: 'paymentInitiated',
    [PaymentDetailType.PaymentCollected]: 'paymentCollected',
    [PaymentDetailType.RefundRequested]: 'refundRequested'
};
export function getPaymentDetailTooltip(details, texts) {
    for (const detail of details){
        const key = PAYMENT_DETAIL_TOOLTIP_TEXT_KEY[detail.type];
        if (key) return texts[key]();
    }
    return '';
}
export function getPaymentDetailLabel(detail, texts, labelOnDate) {
    const label = texts[detail.type]();
    if (isPaymentDetailWithDate(detail) && detail.date) {
        const numericDate = Number(detail.date);
        const formattedDate = isNaN(numericDate) ? timeModel.formatDateLong(new Date(detail.date)) : timeModel.formatDateLong(numericDate);
        return labelOnDate({
            label,
            date: formattedDate
        });
    }
    return label;
}
export function formatPaymentDetailsList(details, texts, labelOnDate) {
    return details.map((detail)=>getPaymentDetailLabel(detail, texts, labelOnDate)).map((label, index)=>index === 0 ? label : label.charAt(0).toLowerCase() + label.slice(1)).join(', ');
}
export function allowResendAction(displayStatusV2, isVendor) {
    return isVendor && displayStatusV2 !== InvoiceDisplayStatusV2.Disputed;
}
const VOIDABLE_DETAIL_TRIGGERS = [
    PaymentDetailType.PaymentStopped,
    PaymentDetailType.PaymentFailed,
    PaymentDetailType.ClientApprovalRequired,
    PaymentDetailType.PaymentValidationRequired,
    PaymentDetailType.PaidExternally
];
export function allowVoidAction(displayStatusV2, paymentDetails, isVendor) {
    if (!isVendor) return false;
    if (paymentDetails.some((d)=>VOIDABLE_DETAIL_TRIGGERS.includes(d.type))) return true;
    if (displayStatusV2 === InvoiceDisplayStatusV2.Disputed) return true;
    return [
        InvoiceDisplayStatusV2.Issued,
        InvoiceDisplayStatusV2.Pending,
        InvoiceDisplayStatusV2.Overdue
    ].includes(displayStatusV2);
}
export function allowUnvoidAction(invoice, isVendor) {
    return isVendor && invoiceSummaryModel.isVoided(invoice);
}
export function allowUnmarkPaidExternallyAction(invoice, isVendor) {
    return isVendor && invoiceSummaryModel.isPaidExternally(invoice);
}
export function getRefundActionConfig(param) {
    let { invoice, isVendor } = param;
    const showAction = isVendor && invoiceModel.rawTotalAmount(invoice).gt(0) && (invoiceModel.isPaid(invoice) || invoiceModel.isConfirmed(invoice) || invoiceModel.isProcessing(invoice) || invoiceModel.isPartiallyRefunded(invoice) || invoiceModel.isRefundFailed(invoice)) && !invoiceModel.isRefundRequested(invoice);
    const daysSincePayment = invoiceModel.daysSincePayment(invoice);
    const payment = invoiceModel.payment(invoice);
    const isOver90Days = payment && payment.isPaymentProcessorStripe() && !!daysSincePayment && daysSincePayment > 90;
    const disabled = !payment || !!isOver90Days;
    const tooltipTitle = isOver90Days ? "This payment can't be refunded—the payment processor's 90-day window has ended." : undefined;
    return {
        showAction,
        disabled,
        tooltipTitle,
        text: 'Refund payment',
        intent: Intent.RequestRefund
    };
}
